import API from "../axiosConfig";

export const getTypeLines = async () => {
  try {
    const response = await API.get("/type_lines");
    return response.data;
  } catch (error) {
    console.error("Error fetching type_lines:", error);
    throw error;
  }
};

export const getTypeLineById = async (id) => {
  try {
    const response = await API.get(`/type_lines/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const createTypeLine = async (typeLineData) => {
  try {
    const response = await API.post("/type_lines", typeLineData);
    return response.data;
  } catch (error) {
    console.error("Error creating section:", error);
    throw error;
  }
};

export const updateTypeLine = async (typeLineId, typeLineData) => {
  try {
    const response = await API.put(`/type_lines/${typeLineId}`, typeLineData);
    return response.data;
  } catch (error) {
    console.error("Error updating section:", error);
    throw error;
  }
};

export const deleteTypeLine = async (typeLineId) => {
  try {
    const response = await API.delete(`/type_lines/${typeLineId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting section:", error);
    throw error;
  }
};
